import React from 'react';
import { useFeature, useFeaturesLoaded } from '../features.js';

// Route guard for 'outsourcing' feature pages (e.g. Control > Carrier), for
// anyone who lands on the URL directly. The server refuses the underlying
// API calls regardless (requireFeature in server/src/db/features.js).
export default function OutsourcingOnly({ children }) {
  const loaded = useFeaturesLoaded();
  const outsourcing = useFeature('outsourcing');
  if (!loaded) return <div className="empty">Loading...</div>;
  if (!outsourcing) {
    return (
      <div className="empty">
        Outsourcing to outside carriers isn't enabled for your account. Contact TruckFlow to turn it on.
      </div>
    );
  }
  return children;
}
